export default "__VITE_ASSET__BLNCZRjP__"